import styles from './Footer.module.css';
import React from 'react';
import { ReactComponent as Logo } from "../../Resources/image/logo.svg";
import { ReactComponent as AppStore } from "../../Resources/image/appstorebadge.svg";
import { t } from "../../utils/i18n";

const Footer = props => {
    const {
        
    } = props;

    return (
        <div className={styles.footer}>
            <div className={styles.sections}>
              <div className={styles.infoLeft}>
                <img className={styles.google} src={require("../../Resources/image/googleplaybadge.png")} alt="Google Play Badge" />
                <AppStore className={styles.apple} />
              </div>
              <div className={styles.endRight}>
                <img className={styles.social} src={require("../../Resources/image/twitter.png")} alt="Twitter Logo" />
                <img className={styles.social} src={require("../../Resources/image/instagram.png")} alt="Instagram Logo" />
              </div>
            </div>
    
            <div className={styles.footerInfo}>
              <div className={styles.endLeft}>
                <h4>{t("footer.privacy", "Privacy")}</h4>
                <h4>{t("footer.security", "Security")}</h4>
                <h4>{t("footer.cookies", "Cookies")}</h4>
                <h4>{t("footer.legal", "Legal")}</h4>
                <h4>{t("footer.guidelines", "Collaborative Guidelines")}</h4>
                <h4>{t("footer.about", "About")}</h4>
              </div>
              
            </div>
        </div>
    );
  }
  
  export default Footer;